// Updated GSAP ScrollTrigger script for all sections
// Make sure GSAP and ScrollTrigger are loaded before this script

// Wait until DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // === SECTION 1: Our Mission Animation ===
  const missionSection = document.querySelector('.s-our-mission');
  if (missionSection) {
    const firstImageDesktop = missionSection.querySelector('.s-our-mission__img--desktop');
    const firstImageMobile = missionSection.querySelector('.s-our-mission__img--mobile');
    const tag = missionSection.querySelector('.s-our-mission__tag');
    const title = missionSection.querySelector('.s-our-mission__title');
    const description = missionSection.querySelector('.s-our-mission__description');
    const secondImageDesktop = missionSection.querySelectorAll('.s-our-mission__second-image .s-our-mission__img--desktop');
    const secondImageMobile = missionSection.querySelectorAll('.s-our-mission__second-image .s-our-mission__img--mobile');
    const bottomText = missionSection.querySelector('.s-our-mission__text');

    // Section fade-out as you scroll past
    gsap.fromTo(
      missionSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: missionSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );
  
    // First image(s) fade/scale in
    [firstImageDesktop, firstImageMobile].forEach((img) => {
      if (img) {
        gsap.fromTo(
          img,
          { x: 60, opacity: 0 },
          {
            x: 0,
            scale: 1,
            opacity: 1,
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
              trigger: img,
              start: "top 80%",
              end: "top 60%",
              scrub: true
            }
          }
        );
      }
    });
  
    // Tag
    if (tag) {
      gsap.fromTo(
        tag,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: tag,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Title
    if (title) {
      gsap.fromTo(
        title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Description
    if (description) {
      gsap.fromTo(
        description,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: description,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Second image(s) animation
    [...secondImageDesktop, ...secondImageMobile].forEach((img) => {
      gsap.fromTo(
        img,
        { x: -60, opacity: 0 },
        {
          x: 0,
          scale: 1,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: img,
            start: "top 80%",
            end: "top 60%",
            scrub: true
          }
        }
      );
    });
  
    // Bottom text with image + 360 spin on entry
    if (bottomText) {
      gsap.fromTo(
        bottomText,
        { y: 30, opacity: 0, rotate: 0 },
        {
          y: 0,
          opacity: 1,
          rotate: -360,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: bottomText,
            start: "top 80%",
            toggleActions: "play reverse play reverse",
          }
        }
      );
    }
  }

  // === SECTION 2: Image With Text Animation ===
  const imageWithTextSection = document.querySelector('.s-image-with-text');
  if (imageWithTextSection) {
    const title = imageWithTextSection.querySelector('.s-image-with-text__title');
    const description = imageWithTextSection.querySelector('.s-image-with-text__description');
    const imageDesktop = imageWithTextSection.querySelector('.s-image-with-text__img--desktop');
    const imageMobile = imageWithTextSection.querySelector('.s-image-with-text__img--mobile');
    const quote = imageWithTextSection.querySelector('.s-image-with-text__image-quote');

    // Section fade-out as you scroll past
    gsap.fromTo(
      imageWithTextSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: imageWithTextSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );
  
    // Animate desktop & mobile images (separately, if both exist)
    [imageDesktop, imageMobile].forEach((img) => {
      if (img) {
        gsap.fromTo(
          img,
          { scale: 0.95, opacity: 0 },
          {
            scale: 1,
            opacity: 1,
            duration: 0.4,
            ease: "power2.out",
            scrollTrigger: {
              trigger: img,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
    });
  
    // Animate quote text block
    if (quote) {
      gsap.fromTo(
        quote,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: quote,
            start: 'top 80%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }
  
    // Animate title
    if (title) {
      gsap.fromTo(
        title,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: title,
            start: 'top 80%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }
  
    // Animate description with slight delay
    if (description) {
      gsap.fromTo(
        description,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.2,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: description,
            start: 'top 80%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }
  }

  // === SECTION 3: Brand Ambassador Animations ===
  const ambassadorSection = document.querySelector(".s-brand-ambassador");
  if (ambassadorSection) {
    const title = ambassadorSection.querySelector(".s-brand-ambassador__title");
    const description = ambassadorSection.querySelector(".s-brand-ambassador__description");
    const dogImages = ambassadorSection.querySelectorAll(".s-brand-ambassador__img");
    const badge = ambassadorSection.querySelector(".s-brand-ambassador__review-rating");
    const speechBubble = ambassadorSection.querySelector(".s-brand-ambassador__review-description");
    const button = ambassadorSection.querySelector(".s-brand-ambassador__review-link");

    // Section fade-out as you scroll past
    gsap.fromTo(
      ambassadorSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ambassadorSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );
  
    // Animate title
    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ambassadorSection,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Animate description
    if (description) {
      gsap.fromTo(description,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          delay: 0.2,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: description,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Animate dog images
    dogImages.forEach((img) => {
      gsap.fromTo(img,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: img,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
  
      // Idle pulse loop (independent of scroll)
      gsap.to(img, {
        scale: 1.03,
        duration: 2,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: 1.5
      });
    });
  
    // Badge "stamp" effect
    if (badge) {
      gsap.fromTo(badge,
        { scale: 0.8, opacity: 0, rotate: -10 },
        {
          scale: 1,
          opacity: 1,
          rotate: 0,
          duration: 0.5,
          ease: "back.out(2)",
          scrollTrigger: {
            trigger: badge,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Speech bubble pop-in
    if (speechBubble) {
      gsap.fromTo(speechBubble,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: speechBubble,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Animate button pop-in
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // === SECTION 4: Footer Banner Animation ===
  const footerBanner = document.querySelector('.s-footer-banner');
  if (footerBanner) {
    const title = footerBanner.querySelector('.s-footer-banner__title');
    const description = footerBanner.querySelector('.s-footer-banner__description');
    const button = footerBanner.querySelector('.s-footer-banner__link');
    const imageWrapper = footerBanner.querySelector('.s-footer-banner__image-wrapper');
  
    // Animate title separately
    if (title) {
      gsap.fromTo(
        title,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: title,
            start: 'top 80%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }
  
    // Animate description separately
    if (description) {
      gsap.fromTo(
        description,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.2,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: description,
            start: 'top 80%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }
  
    // Animate CTA button
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: 'back.out(1.7)',
          scrollTrigger: {
            trigger: button,
            start: 'top 80%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }
  
    // Animate image wrapper
    if (imageWrapper) {
      gsap.fromTo(
        imageWrapper,
        { opacity: 0, scale: 0.98 },
        {
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: imageWrapper,
            start: 'top 80%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }
  }

  // === SECTION 5: Feature Slider Animations ===
  const featureSlider = document.querySelector(".s-feature-slider");
  if (featureSlider) {
    const title = featureSlider.querySelector(".s-feature-slider__title");
    const slides = featureSlider.querySelectorAll(".s-feature-slider__slide");

    gsap.fromTo(
      featureSlider,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: featureSlider,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: featureSlider,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    slides.forEach((slide, index) => {
      gsap.fromTo(slide, { y: 40, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 0.6,
        delay: index * 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slide,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      });
    });
  }

  // === SECTION 6: Catalog Download Animation ===
  const catalogSection = document.querySelector('.s-catalog-download');

  if (catalogSection) {
    const title = catalogSection.querySelector('.s-catalog-download__title');
    const text = catalogSection.querySelector('.s-catalog-download__text');
    const button = catalogSection.querySelector('.why-us-section__link');

    // Section fade-out
    gsap.fromTo(
      catalogSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: catalogSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Title animation
    if (title) {
      gsap.fromTo(
        title,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Text animation
    if (text) {
      gsap.fromTo(
        text,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.15,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: text,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Button animation (same style as others)
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.35,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // === SECTION 7: Video Strip Animation ===
  const videoStrip = document.querySelector('.video-strip');

  if (videoStrip) {
    const videoItems = videoStrip.querySelectorAll('.video-item');
    const videos = videoStrip.querySelectorAll('.tap-video');
    const videoFooter = document.querySelector('.video-footer');

    gsap.fromTo(
      videoStrip,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: videoStrip,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (videoItems.length) {
      gsap.fromTo(
        videoItems,
        { y: 50, opacity: 0, scale: 0.96 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.7,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: videoStrip,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    videos.forEach((video) => {
      gsap.fromTo(
        video,
        { scale: 0.97 },
        {
          scale: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: video,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });

    if (videoFooter) {
      gsap.fromTo(
        videoFooter,
        { y: 24, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.55,
          ease: "power2.out",
          scrollTrigger: {
            trigger: videoFooter,
            start: "top 90%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // === SECTION 8: Video Footer Animation ===
  const videoFooter = document.querySelector('.video-footer');

  if (videoFooter) {
    gsap.fromTo(
      videoFooter,
      { y: 24, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.55,
        ease: "power2.out",
        scrollTrigger: {
          trigger: videoFooter,
          start: "top 90%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  // Always refresh ScrollTrigger to ensure layout is measured correctly
  ScrollTrigger.refresh();
});
